import { createIcon } from '../../icons';
import { formatDate, checkDateValidity } from '../../../../Foundation/utils';
import { evaluateWarrantyDate } from '../utils/evaluateWarrantyDates';

// Visual shell only: fields inside `.item-card__configurator-mount` are owned by ServiceFlowConfigurator
export function buildItemCard(item, translations, warrantyConfig, onRemove) {
  const serialNo = item.serialNo || item.SerialNo || '';
  const patientName = item.patientName || item.Patient || '';
  const productName = item.productName || item.ModelNo || '';

  const card = document.createElement('div');
  card.className = 'item-card';
  card.setAttribute('data-item-card', '');
  card.setAttribute(
    'data-item-card-config',
    JSON.stringify({
      serialNo,
      productName,
    }),
  );

  const body = document.createElement('div');
  body.className = 'item-card__body';

  const productWrapper = document.createElement('div');
  productWrapper.className = 'item-card__product-wrapper';

  const product = document.createElement('div');
  product.className = 'item-card__product';

  const imagePlaceholder = document.createElement('div');
  imagePlaceholder.className = 'item-card__product-image-placeholder';
  if (item.imageUrl && item.imageUrl.trim() !== '') {
    const img = document.createElement('img');
    img.className = 'item-card__product-image';
    img.src = item.imageUrl;
    img.alt = productName;

    img.addEventListener('error', () => {
      img.remove();
      imagePlaceholder.classList.add('item-card__product-image-placeholder--empty');
    });

    imagePlaceholder.appendChild(img);
  } else {
    imagePlaceholder.classList.add('item-card__product-image-placeholder--empty');
  }

  const productBody = document.createElement('div');
  productBody.className = 'item-card__product-body';

  if (productName && productName.trim() !== '') {
    const productNameElement = document.createElement('span');
    productNameElement.className = 'item-card__product-name';
    productNameElement.textContent = productName;
    productBody.appendChild(productNameElement);
  }

  productBody.appendChild(
    buildProductRow(translations.serialNoLabel || 'Serial no.:', serialNo || '-'),
  );
  productBody.appendChild(
    buildProductRow(translations.patientNameLabel || 'Patient name:', patientName || '-'),
  );
  productBody.appendChild(buildWarrantyRow(item, translations, warrantyConfig));

  product.append(imagePlaceholder, productBody);

  const line = document.createElement('div');
  line.className = 'item-card__line';

  productWrapper.append(product, line);

  const configuratorSlot = document.createElement('div');
  configuratorSlot.className = 'item-card__configurator-mount';

  const removeBtn = document.createElement('button');
  removeBtn.type = 'button';
  removeBtn.className = 'item-card__remove';
  removeBtn.setAttribute('aria-label', translations.removeLabel || 'Remove item');
  removeBtn.appendChild(createIcon('remove'));
  removeBtn.addEventListener('click', () => onRemove?.(card, item));

  body.append(productWrapper, configuratorSlot, removeBtn);
  card.appendChild(body);
  return card;
}

function buildProductRow(labelText, valueText) {
  const row = document.createElement('div');
  row.className = 'item-card__product-row';

  const label = document.createElement('span');
  label.className = 'item-card__product-label';
  label.textContent = labelText;

  const value = document.createElement('span');
  value.className = 'item-card__product-value';
  value.textContent = valueText;

  row.append(label, value);
  return row;
}

function buildWarrantyRow(item, translations, warrantyConfig) {
  const row = document.createElement('div');
  row.className = 'item-card__product-row';

  const label = document.createElement('span');
  label.className = 'item-card__product-label';
  label.textContent = translations.repairWarrantyLabel || 'Repair warranty:';

  const value = document.createElement('span');
  const rawWarranty = item.repairWarranty || item.RepairWarrantyEndDate || '';
  const longDateFormat = warrantyConfig?.LongDateFormat || 'dd-mm-yyyy';
  const warranty = checkDateValidity(rawWarranty)
    ? formatDate(rawWarranty, longDateFormat)
    : rawWarranty;
  const { modifier } = evaluateWarrantyDate(rawWarranty, false);
  value.className = modifier
    ? `item-card__product-value item-card__product-value--warranty item-card__product-value--${modifier}`
    : 'item-card__product-value';
  value.textContent = warranty || '-';

  row.append(label, value);
  return row;
}
